import { Tabs, TabsContent, TabsList, TabsTrigger } from '@folio/components';
import { useTranslation } from 'react-i18next';
import { IntermediaryList } from './IntermediaryList';

export function IntermediaryTabsModule() {
  const { t } = useTranslation();

  return (
    <Tabs defaultValue="intermediary">
      <TabsList className="grid grid-cols-3">
        <TabsTrigger value="intermediary">{t('intermediaryTabs.intermediaryTabTitle')}</TabsTrigger>
        <TabsTrigger value="waitingDistributionRequests">
          {t('intermediaryTabs.waitingDistributionRequestsTabTitle')}
        </TabsTrigger>
        <TabsTrigger value="refusedDistributionRequests">
          {t('intermediaryTabs.refusedDistributionRequestsTabTitle')}
        </TabsTrigger>
      </TabsList>
      <TabsContent value="intermediary">
        <IntermediaryList title={t('intermediaryTabs.intermediaryListTitle')} viewType="approved" />
      </TabsContent>
      <TabsContent value="waitingDistributionRequests">
        <IntermediaryList
          title={t('intermediaryTabs.waitingDistributionRequestsListTitle')}
          viewType="waiting"
        />
      </TabsContent>
      <TabsContent value="refusedDistributionRequests">
        <IntermediaryList
          title={t('intermediaryTabs.refusedDistributionRequestsListTitle')}
          viewType="refused"
        />
      </TabsContent>
    </Tabs>
  );
}
